import { isMainWindow } from '../../services/container/windows-management'
import { getLaunchDarklyFlag } from '../../services/feature-flags'
import { LaunchDarklyVariations } from '../../services/feature-flags/models'
import { doLoadKeyboardShortcutConfiguration } from '../../services/keyboard-shortcut/keyboard-shortcut'
import { subscribeToKeyboardShortcutConfigurationChange } from '../../services/keyboard-shortcut/keyboard-shortcut-events'
import type { ShellHook } from './models'
import { Plugins } from '@getgo/container-client'
import { getShellLogger } from '../../common/logger'

export const initializeKeyboardShortcuts: ShellHook = async () => {
  if (getLaunchDarklyFlag(LaunchDarklyVariations.SHELL_KEYBOARD_SHORTCUT_EDITING)) {
    subscribeToKeyboardShortcutConfigurationChange()
    Plugins.KeyboardShortcuts.systemInterface.initializeLogger(getShellLogger().create('keyboardShortcuts'))
    if (isMainWindow()) {
      await doLoadKeyboardShortcutConfiguration()
    }
  }
}
